// モーダルウィンドウとボタンの要素を取得
var modal = document.getElementById("myModal");
var btn = document.getElementById("openModal");
var span = document.getElementsByClassName("close")[0];

// ボタンクリックでモーダルを表示
btn.onclick = function() {
  modal.style.display = "block";
}

// ×ボタンをクリックでモーダルを非表示に
span.onclick = function() {
  modal.style.display = "none";
}

// モーダル外のエリアをクリックでモーダルを非表示に
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
